export default __webpack_public_path__ + "static/media/YouTube.47f217d6.svg";